import Constants from './constants'
import DER from './der'

const TagTypes = Constants.TagTypes

function get_len (data, offset) {
  const leadingByte = data.readUInt8(offset)
  const lenHasMultipleBytes = (leadingByte & 0x80) === 0x80
  if (lenHasMultipleBytes) {
    const numBytes = leadingByte & 0x7f
    let len
    switch (numBytes) {
      case 1:
        len = data.readUInt8(offset + 1)
        break
      case 2:
        len = data.readUInt16BE(offset + 1)
        break
      case 4:
        len = data.readUInt32BE(offset + 1)
        break
      default:
        throw new Error(
          `Expected numBytes to be one of [1, 2, 4], but got 0x${numBytes.toString(
            16
          )}, original byte 0x${leadingByte.toString(16)}`
        )
    }
    return [numBytes + 1, len]
  } else {
    return [1, leadingByte]
  }
}

function isTagAList (tag) {
  return tag === Constants.UniversalTags.SEQUENCE || tag === Constants.UniversalTags.SET
}

function get_tlv_universal (data, offset) {
  const tag = data.readUInt8(offset)

  const [lenOfLen, lenOfValue] = get_len(data, offset + 1)
  const lenOfTlv = 1 + lenOfLen + lenOfValue

  const valueStart = offset + 1 + lenOfLen
  const value = data.slice(valueStart, valueStart + lenOfValue)

  const tagStr = Constants.tag_to_type(tag)

  const tlv = {
    tag: tag,
    tagStr: tagStr,
    len: lenOfValue,
    value: value,
    lenOfTlv: lenOfTlv,
    lenOfLen: lenOfLen,
    offset: offset
  }

  if (isTagAList(tag)) {
    const tlvs = []
    let subOffset = 0
    for (;;) {
      const tlv = get_tlv(value, subOffset)
      if (tlv !== undefined) {
        tlvs.push(tlv)
        subOffset = subOffset + tlv.lenOfTlv
      } else {
        break
      }
    }
    tlv.parsedResult = tlvs
    return tlv
  } else {
    const parsedResult = DER.parse(tlv)
    tlv.parsedResult = parsedResult
    return tlv
  }
}

function get_tlv_contextspecific (data, offset) {
  const tag = data.readUInt8(offset)
  const [lenOfLen, lenOfValue] = get_len(data, offset + 1)
  const lenOfTlv = 1 + lenOfLen + lenOfValue

  const valueStart = offset + 1 + lenOfLen
  const value = data.slice(valueStart, valueStart + lenOfValue)
  const tagStr = Constants.tag_to_type(tag)

  const tlv = {
    tag: tag,
    tagStr: tagStr,
    len: lenOfValue,
    value: value,
    lenOfTlv: lenOfTlv,
    lenOfLen: lenOfLen,
    offset: offset
  }
  return tlv
}

// This function returns a tlv and the next offset to continue parsing
function get_tlv (data, offset) {
  if (offset >= data.length) {
    return undefined
  }

  // The tag type is defined by the two highest bits
  const tagByte = data.readUInt8(offset)
  const tagType = Constants.getTagType(tagByte)

  switch (tagType) {
    case TagTypes.Universal:
      return get_tlv_universal(data, offset)
    case TagTypes.Application:
      throw new Error('err')
    case TagTypes.ContextSpecific:
      return get_tlv_contextspecific(data, offset)
    case TagTypes.Private:
      throw new Error()
    default:
      throw new Error()
  }
}

// Converts binary data into TLV tokens
function tokenize (data) {
  const tlvs = []
  let offset = 0
  while (offset < data.length) {
    const tlv = get_tlv(data, offset)
    tlvs.push(tlv)
    offset = offset + tlv.lenOfTlv
  }

  return tlvs
}

export default { tokenize, get_len }
